import styled from 'styled-components';
import { ChevronDownSmall } from 'ui/icons';
import { GhostButton } from 'ui/button';
import { ExpandModes, useExpansionContext } from 'utils/contexts/expansion';

import { useTranslation } from '../../hooks';

type ExpansionToggleButtonProps = {
  hasMeterChart?: boolean;
};

const StyledButton = styled(GhostButton)<{ $isExpanded: boolean; $hasMeterChart: boolean }>`
  grid-column: ${({ $hasMeterChart }) => ($hasMeterChart ? '1 / span 4' : '1 / span 2')};
  justify-self: center;

  svg {
    margin-left: ${({ theme }) => theme.spacing.values.quarter};
    transform: rotate(${({ $isExpanded }) => ($isExpanded ? '180deg' : '0deg')});
    transition: 0.25s transform ease;
  }
`;

export const ExpansionToggleButton = ({ hasMeterChart = false }: ExpansionToggleButtonProps) => {
  const { mode, toggle } = useExpansionContext();
  const { t } = useTranslation();
  const isExpanded = mode === ExpandModes.expand;

  return (
    <StyledButton
      onClick={toggle}
      $isExpanded={isExpanded}
      $hasMeterChart={hasMeterChart}
      data-test="expansion-toggle-button"
    >
      {t(isExpanded ? 'insights.collapse' : 'insights.expand')}
      <ChevronDownSmall />
    </StyledButton>
  );
};
